import BkashPayment from "@/views/BkashPayment";

export default [
    {
        path: '/payment-method',
        name: 'BkashPayment',
        component: BkashPayment,
        meta: {
            requiresAuth: true
        }
    }
];
